import { ArrowLeft } from '@assets/svgs';
import { Tab } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { backBtnStyle } from '@components/panel/PanelBackButton/PanelBackButton.styles';

export const PanelBackButton = (props: { children: string; url?: string; fallbackUrl?: string }) => {
  const { children, url, fallbackUrl } = props;
  const navigate = useNavigate();

  const handleNavigate = () => {
    if (url) {
      navigate(url);
    } else {
      // Determine if there is a page in history
      const hasHistory = window.history.length > 1;

      if (!hasHistory && fallbackUrl) {
        navigate(fallbackUrl);
      } else {
        navigate(-1);
      }
    }
  };

  return <Tab label={children} icon={<ArrowLeft />} iconPosition='start' sx={backBtnStyle} onClick={handleNavigate} />;
};
